import "./styles.css";
import translations from "@/config/translations";
import useLangStore from "@/hooks/useLangStore";

interface ActionItem {
    name: string;
    icon: string;
    handler: () => void;
    danger?: boolean;
}

export interface ActionMenuPopupDetails {
    actions: ActionItem[];
}

interface Props {
    onClose: () => void;
    details?: ActionMenuPopupDetails;
}

export default function ActionMenuPopup({ onClose, details }: Props) {
    const { lang } = useLangStore();
    const t = translations[lang ?? "ar"];
    const actions = details?.actions ?? [];

    const getLabel = (name: string) => {
        const actionTranslations = t.table.actions as Record<string, string>;
        return actionTranslations[name] ?? name;
    };

    const handleClick = (handler: () => void) => {
        handler();
        onClose();
    };

    return (
        <div className="action-menu-popup">
            {actions.map((action) => (
                <button
                    key={action.name}
                    type="button"
                    className={`action-menu-item${action.danger ? " action-menu-item--danger" : ""}`}
                    onClick={() => handleClick(action.handler)}
                >
                    <img src={action.icon} alt="" className="action-menu-item-icon" />
                    <span>{getLabel(action.name)}</span>
                </button>
            ))}
        </div>
    );
}
